export function getAllRecipientsAsEmailAddressStrings(composeViewState) {
    var recipientsAsEmailAddressStrings = [];
    recipientsAsEmailAddressStrings = recipientsAsEmailAddressStrings.concat(getEmailAddressesFromWellViewState(composeViewState.toRecipientWell));
    recipientsAsEmailAddressStrings = recipientsAsEmailAddressStrings.concat(getEmailAddressesFromWellViewState(composeViewState.ccRecipientWell));
    recipientsAsEmailAddressStrings = recipientsAsEmailAddressStrings.concat(getEmailAddressesFromWellViewState(composeViewState.bccRecipientWell));
    return recipientsAsEmailAddressStrings;
}
function getEmailAddressesFromWellViewState(wellViewState) {
    var emailAddresses = [];
    if (wellViewState && wellViewState.recipients) {
        wellViewState.recipients.forEach(function (recipientViewState, index) {
            emailAddresses[index] = recipientViewState.persona.EmailAddress.EmailAddress;
        });
    }
    return emailAddresses;
}
//# sourceMappingURL=getAllRecipientsAsEmailAddressStrings.js.map